import { createStore } from 'owa-satcheljs';
import type { EasidResponse } from 'owa-licensing-utils/lib/schema/EasidResponse';
import type {
    EasidLinkStore,
    PremiumStatus,
    DialogState,
    EntryPoint,
} from './schema/EasidLinkStore';
import { getAccountKeyForMailboxInfo, type MailboxInfo } from 'owa-client-types';

export function getDialogStateKey(mailboxInfo: MailboxInfo, entryPoint: EntryPoint): string {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    return `${accountKey}${entryPoint}`;
}

export const getEasidLinkStore: () => EasidLinkStore = createStore<EasidLinkStore>(
    'easidLinkStore',
    {
        entries: new Map<string, EasidResponse>(),
        premiumEntries: new Map<string, PremiumStatus>(),
        dialogState: new Map<string, DialogState>(),
        accountToLink: undefined,
    }
);
